module.exports = __webpack_public_path__ + "img/the_phoenix.057f8f8c.jpg";